// extracted by mini-css-extract-plugin
export var currencyInput = "_ls-1";
export var currencySymbol = "_ls-0";